module.exports = __webpack_public_path__ + "img/6e8b070.png";